/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const es_kyc_gate_modal_description = /** @type {(inputs: {}) => string} */ () => {
	return `Para proteger tu cuenta y cumplir con las regulaciones, por favor verifica tu identidad antes de usar funciones transaccionales como tarjetas, cuentas y transferencias.`
};

const en_kyc_gate_modal_description = /** @type {(inputs: {}) => string} */ () => {
	return `To protect your account and comply with regulations, please verify your identity before using transactional features like cards, accounts, and transfers.`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
const kyc_gate_modal_description = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.kyc_gate_modal_description(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("kyc_gate_modal_description", locale)
	if (locale === "es") return es_kyc_gate_modal_description(inputs)
	return en_kyc_gate_modal_description(inputs)
};
export { kyc_gate_modal_description as "kyc_gate.modal_description" }